import AuthService from '@/services/AuthService';
import IziToastExternal from '@/utils/iziToastExternal';

const state = {
  admin: false
}

const getters = {
  userIsAdmin: state => state.admin
}

const actions = {
  setUserIsAdmin ({ commit }) {
    return new Promise((resolve, reject) => {
      AuthService.userIsAdmin().then(response => {
        commit('SET_USER_IS_ADMIN', response);
        resolve(true);
      })
      .catch((e) => {
        console.error('Erro ao executar função setUserIsAdmin: ', e);
        IziToastExternal.error('Falha ao resgatar dados do usuário - 1.3', '', {
          position: 'topRight',
          timeout: 1000,
          onClosed: () => AuthService.logout()
        });
        reject(true);
      });
    });
  },
  resetUserIsAdminModule({ commit }) {
    commit('SET_USER_IS_ADMIN', false)
  }
}

const mutations = {
  SET_USER_IS_ADMIN: (state, value) => (state.admin = value)
}

export default {
  state,
  getters,
  actions,
  mutations
}